/* eslint-disable react-hooks/exhaustive-deps */

import { WMS_LGS_PEMBELIAN } from "App/constants";
import { isNull } from "App/utils/helpers";
import React, { createContext, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { FORM_RESET_STATE_WMS_PEMBELIAN } from "../helpers";

export const FormContext = createContext();

export const FormProvider = ({ data, children, menu }) => {
  const oldFormData = useRef(null);
  const stateRedux = useSelector((state) => state);
  const setting = stateRedux.setting;
  const KAS = setting.default_kas;

  const [formData, setFormData] = useState(() => {
    if (isNull(data)) {
      return {
        ...FORM_RESET_STATE_WMS_PEMBELIAN,
        kasbank_id: KAS.kas_id,
        kasbank: KAS.kas_nama,
        coa_code: KAS.coa_code,
      };
    } else {
      if (menu === WMS_LGS_PEMBELIAN) {
        oldFormData.current = data;
        return data;
      } else {
        if (isNull(oldFormData.current)) {
          return {
            ...FORM_RESET_STATE_WMS_PEMBELIAN,
            kasbank_id: KAS.kas_id,
            kasbank: KAS.kas_nama,
            coa_code: KAS.coa_code,
          };
        } else {
          return oldFormData.current;
        }
      }
    }
  });

  useEffect(() => {
    if (isNull(data)) {
      setFormData({
        ...FORM_RESET_STATE_WMS_PEMBELIAN,
        kasbank_id: KAS.kas_id,
        kasbank: KAS.kas_nama,
        coa_code: KAS.coa_code,
      });
    } else {
      if (menu === WMS_LGS_PEMBELIAN) {
        oldFormData.current = data;
        setFormData(data);
      } else {
        if (isNull(oldFormData.current)) {
          setFormData({
            ...FORM_RESET_STATE_WMS_PEMBELIAN,
            kasbank_id: KAS.kas_id,
            kasbank: KAS.kas_nama,
            coa_code: KAS.coa_code,
          });
        } else {
          setFormData(oldFormData.current);
        }
      }
    }
  }, [data]);

  return (
    <FormContext.Provider value={{ formData, setFormData, KAS }}>
      {children}
    </FormContext.Provider>
  );
};
